import { render } from "./ShipmentSizeCreating.vue?vue&type=template&id=34225ea4&ts=true"
import script from "./ShipmentSizeCreating.vue?vue&type=script&lang=ts"
export * from "./ShipmentSizeCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__